(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["language-switch"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-dropdown-handle]').forEach((handle) => {
    handle.addEventListener('click', function (t) {
      t.preventDefault();
      const dropdown = this.closest('[data-dropdown]');
      if (dropdown.getAttribute('data-dropdown') === 'opened') {
        dropdown.setAttribute('data-dropdown', '');
      } else {
        const group = this.closest('[data-dropdown-group]');
        const insideSlideOver = this.closest('.slideover--filters');
        if (group && !insideSlideOver) {
          group.querySelectorAll('[data-dropdown]').forEach((d) => d.setAttribute('data-dropdown', ''));
        }
        dropdown.setAttribute('data-dropdown', 'opened');
        if (typeof W !== 'undefined' && W.showFilters) W.showFilters(t);
      }
    });
  });

  document.addEventListener('click', function (t) {
    if (!t.target.closest('[data-dropdown-autoclose]')) {
      document.querySelectorAll('[data-dropdown-autoclose]').forEach((d) => {
        d.setAttribute('data-dropdown', '');
      });
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["megamenu"] && !Shopify.designMode) return;
  try {
    /**
   * Mega menu controller (vanilla JS)
   * Matches behavior of the jQuery version:
   * - Open on mouseenter/focus of [data-has-megaroll]
   * - Close on mouseleave of .header
   * - Swap push image/title when hovering links with data-visual-src/data-visual-quote
   *
   * Assumptions:
   * - Trigger is an <a> (or focusable element) with [data-has-megaroll]
   * - The mega panel is the immediate next sibling: trigger.nextElementSibling === .megaroll
   * - Header wrapper exists: .header
   */

  (function initMegaMenu() {
    const header = document.querySelector('.main-header');
    if (!header) return;

    const triggers = Array.from(document.querySelectorAll('[data-has-megaroll]'));

    function closeAll() {
      triggers.forEach((el) => {
        const li = el.closest('li');
        if (li) li.classList.remove('hover');
      });

      document.querySelectorAll('.megaroll.megaroll--current').forEach((el) => {
        el.classList.remove('megaroll--current');
      });

      header.classList.remove('header--megarolled');

      // Keep parity with original snippet
      document.querySelectorAll('.topbar__dropdown[data-dropdown]').forEach((el) => {
        el.setAttribute('data-dropdown', '');
      });

      document.querySelectorAll('.minicart.minicart--visible').forEach((el) => {
        el.classList.remove('minicart--visible');
      });
    }

    function isTruthyDataAttr(el, name) {
      // jQuery's .attr() returns a string or undefined; empty string is falsy in their check.
      const v = el.getAttribute(name);
      return v !== null && v !== '';
    }

    function getNextMegaroll(el) {
      const next = el.nextElementSibling;
      if (next && next.classList && next.classList.contains('megaroll')) return next;
      return null;
    }

    function openForTrigger(trigger, evt) {
      closeAll();

      const hasMega = isTruthyDataAttr(trigger, 'data-has-megaroll');
      const panel = getNextMegaroll(trigger);

      if (hasMega && panel) {
        if (evt) evt.preventDefault();

        const li = trigger.closest('li');
        if (li) li.classList.add('hover');

        panel.classList.add('megaroll--current');
        header.classList.add('header--megarolled');
      }
    }

    // Open on mouseenter + focus
    triggers.forEach((trigger) => {
      trigger.addEventListener('mouseenter', (evt) => openForTrigger(trigger, evt), {
        passive: false,
      });

      trigger.addEventListener('focus', (evt) => openForTrigger(trigger, evt), {
        passive: false,
      });
    });

    // Close when mouse leaves the header area
    header.addEventListener('mouseleave', () => {
      closeAll();
    });

    // Hover swap logic for links with data-visual-src
    const visualLinks = Array.from(document.querySelectorAll('.megaroll__col-links [data-visual-src]'));

    visualLinks.forEach((link) => {
      link.addEventListener('mouseenter', () => {
        const mega = link.closest('[data-megaroll]');
        if (!mega) return;

        const visualSrc = link.getAttribute('data-visual-src');
        const visualQuote = link.getAttribute('data-visual-quote') || '';

        const pushCol = mega.querySelector('.megaroll__col--push');
        if (!pushCol) return;

        // Original requires exactly one push column
        if (mega.querySelectorAll('.megaroll__col--push').length !== 1) return;

        pushCol.classList.remove('megaroll__push--hover-item');

        window.setTimeout(() => {
          const hoverImg = mega.querySelector('.megaroll__push-image--hover-item');
          const pushTitle = mega.querySelector('.megaroll__push-title');

          if (hoverImg && visualSrc) {
            hoverImg.style.backgroundImage = `url(${visualSrc})`;
          }
          if (pushTitle) {
            pushTitle.innerHTML = visualQuote;
          }
        }, 100);

        window.setTimeout(() => {
          pushCol.classList.add('megaroll__push--hover-item');
        }, 200);
      });

      link.addEventListener('mouseleave', () => {
        const mega = link.closest('[data-megaroll]');
        if (!mega) return;

        const pushCol = mega.querySelector('.megaroll__col--push');
        if (!pushCol) return;

        if (mega.querySelectorAll('.megaroll__col--push').length !== 1) return;

        const pushTitle = mega.querySelector('.megaroll__push-title');
        const originalTitle = pushTitle ? pushTitle.getAttribute('data-megaroll-push-title') || '' : '';

        window.setTimeout(() => {
          pushCol.classList.remove('megaroll__push--hover-item');
          if (pushTitle) pushTitle.innerHTML = originalTitle;
        }, 200);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-colors"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const container = document.querySelector('[data-product-colors]');
    if (!container) return;

    const trigger = container.querySelector('[data-dropdown-trigger]');
    const content = container.querySelector('[data-dropdown-content]');
    const closeBtn = container.querySelector('[data-dropdown-close]');

    if (!trigger || !content) return;

    const toggleDropdown = (forceClose = false) => {
      const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
      const shouldClose = forceClose || isExpanded;

      trigger.setAttribute('aria-expanded', !shouldClose);
      content.setAttribute('aria-hidden', shouldClose);
    };

    trigger.addEventListener('click', (e) => {
      e.stopPropagation();
      toggleDropdown();
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        toggleDropdown(true);
      });
    }

    document.addEventListener('click', (e) => {
      if (!container.contains(e.target)) {
        toggleDropdown(true);
      }
    });

    window.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        toggleDropdown(true);
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
